import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/preview/place/$placeIdOrSlug')({
  loader: ({ params }) => {
    throw redirect({ to: `/place/${params.placeIdOrSlug}`, statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
